import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {BerthVisit, Exemption_3_2} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-visit-exemptions-exemption-3-2',
    templateUrl: './exemption_3_2.component.html',
    styleUrls: ['./exemption_3_2.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_3_2Component extends ExemptionBaseComponent {
  @Input() exemption : Exemption_3_2;
  @Input() berthVisit : BerthVisit;

  allowedBerths = new Set<string>([
                                          'YUKONH GATE STG3',
                                          'NIJLH GATE STG 1',
                                          'NIJLH GATE STG 2'
                                          ]);

  displayBertRelatedFields(): boolean {
    return this.allowedBerths.has(this.berthVisit.berth.name);
  }
}

